/**
 * Audit-log read contracts.
 *
 * The backend writes an immutable audit row on every entity mutation (see
 * `security/audit.service`). These types expose a per-entity history feed used by the
 * "History" tab on entity editors. Keep this file free of runtime dependencies.
 */
/** Entity types that expose a history feed on their editor. */
export const AUDIT_ENTITY_TYPES = [
    'Ticket',
    'Customer',
    'Opportunity',
    'Timesheet',
    'Project',
    'TimeEntry',
    'Invoice',
    'Agreement',
    'Onboarding',
    'Quote',
    'QuoteTemplate',
];
export const AUDIT_ACTION_LABELS = {
    create: 'Created',
    update: 'Updated',
    delete: 'Deleted',
};
//# sourceMappingURL=audit.js.map